import React, { useEffect } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AppState, useAppDispatch } from 'stores/type';
import { useIntl } from 'react-intl';
import { closeDialog, showDialog } from 'stores/dialogSlice';
import { clearErrorMessageLocaleId } from 'stores/errorSlice';
import { localeIds } from 'locals';
import { HandleExceptionErrorPage } from 'views/pages/errors/HandleExceptionErrorPage';
import { Dialog } from 'views/components/molecules/Dialog';

export const HandleAsyncError: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const { errorState, dialogState } = useSelector((state) => state);
  const { messageLocaleId: errorMessageLocaleId } = errorState;
  const exceptionError = errorState.exceptionError;
  const { shown, content, title, defaultAction, cancelAction } = dialogState;

  const handleClearError = React.useCallback(() => {
    dispatch(closeDialog());
    dispatch(clearErrorMessageLocaleId());
  }, [dispatch]);

  useEffect(() => {
    if (!errorMessageLocaleId) {
      return;
    }

    // Errorをalertで表示する
    dispatch(
      showDialog({
        content: intl.formatMessage({ id: errorMessageLocaleId }),
        defaultAction: {
          label: intl.formatMessage({ id: localeIds.dialog.ok }),
          callback: handleClearError,
        },
      })
    );
  }, [dispatch, handleClearError, errorMessageLocaleId, intl]);

  const handleClose = React.useCallback(() => {
    dispatch(closeDialog());
  }, [dispatch]);

  if (exceptionError) {
    return <HandleExceptionErrorPage error={exceptionError} />;
  } else {
    return (
      <>
        {children}
        <Dialog
          title={title}
          content={content}
          defaultAction={defaultAction}
          cancelAction={cancelAction}
          shown={shown}
          onClose={handleClose}
        />
      </>
    );
  }
};
